import React, {useRef} from 'react';



const ContactFormInput = ({ placeholder, name, onChange }) => {
  const inputEl = useRef();

  const handleFocus = () => {
    if (!inputEl.current) {
      return;
    }

    inputEl.current.classList.add('form-input_focused');
  };

  const handleBlur = (event) => {
    if (!inputEl.current) {
      return;
    }

    if (!event || !event.currentTarget.value) {
      inputEl.current.classList.remove('form-input_focused');
    }
  };


  return (
      <>
        <div ref={inputEl} className="form-input">
          <label htmlFor={`contact-form-input_${name}`} className="form-input__placeholder">
            {placeholder}
          </label>
          <input
              required
              id={`contact-form-input_${name}`}
              name={name}
              onBlur={handleBlur}
              onChange={e => onChange(e.target.value)}
              onFocus={handleFocus}
          />
        </div>
      </>
  );
}

export default ContactFormInput;
